import qcareApi from "./qcareApi";
import { ImageTemp } from "../interfaces/intakes.reports"
import { useMutation, useQueryClient } from "@tanstack/react-query";

interface Base {
    reportId: string
    palletId: string
}

export interface PalletImages extends Base {
    images: ImageTemp[]
}

export interface BatchImages {
    images: ImageTemp[]
    reportId: string
}

const uploadPalletImages = async (uploadData: PalletImages) => {

    if(uploadData.images.length === 0) return { reportId: uploadData.reportId}
    const formData = new FormData();

    // Filtrar solo archivos válidos antes de agregarlos
    const validFiles = uploadData.images.filter(img => img.file instanceof File);

    for (const img of validFiles) {
        formData.append('uploady', img.file)
    }

    formData.append('reportId', uploadData.reportId)
    formData.append('palletId', uploadData.palletId)

    const { data } = await qcareApi.post('/report/add-files', formData)
    return data
};

const uploadBatchImages = async (uploadData: BatchImages) => {

    if(uploadData.images.length === 0) return { reportId: uploadData.reportId}
    const formData = new FormData();

    for (const img of uploadData.images) {
        formData.append('uploady', img.file)
    }

    formData.append('reportId', uploadData.reportId)

    const { data } = await qcareApi.post('/report/upload-batch-images', formData)
    return data
};


//--------------- HOOKS ------------------//


export const useImageToPallet = () => {
    const queryClient = useQueryClient()
    return useMutation(uploadPalletImages,
        { onSuccess: async (data) => {
            await queryClient.invalidateQueries(['report', data.reportId])
        } }
    )
}

export const useAddBatchImages = () => {
    const queryClient = useQueryClient()
    return useMutation(uploadBatchImages,
        { onSuccess: async (data) => {
            await queryClient.invalidateQueries(['report', data.reportId])
        } }
    )
}